module.exports = __webpack_public_path__ + "static/media/map-pin.d20f662b.svg";